module.exports = __webpack_public_path__ + "53bb5b70a81a855339752decb17cc89e.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Aside/images/bio-marc-04.jpg
 ** module id = 361
 ** module chunks = 0
 **/